import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ConfirmModal } from './confirm.modal';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [ConfirmModal],
  entryComponents: [
    ConfirmModal
  ],
  exports: [
    ConfirmModal
  ]
})
export class ConfirmModalModule {}
